import type { TransformedResolutionFailure } from '@library/types/resolutions/resolutionDetails';

export interface ResolutionFailuresRowsProps {
  rowData: TransformedResolutionFailure;
  index: number;
}

export const ResolutionFailuresRows = ({
  rowData,
  index
}: ResolutionFailuresRowsProps) => {
  const { description, newWagerId } = rowData;

  return (
    <div className="border-soFresh-130 max-w-[544px] self-stretch border-b">
      <div className="border-soFresh-130 bg-soFresh-110 mx-4 flex h-12 items-center border-b px-4 text-xs">
        <div className="text-soClean-180 mx-4 flex flex-col justify-center self-stretch px-4">
          {index + 1}
        </div>
        <div className="text-soClean-100 mx-4 flex flex-col justify-center self-stretch px-4">
          {newWagerId}
        </div>
        <div className="text-soClean-100 mx-4 flex grow flex-col justify-center self-stretch px-4">
          {description}
        </div>
      </div>
    </div>
  );
};
